
import commonImg from '~/components/common/commonImg.vue'
import qrCode from '~/components/j/qrCode.vue'
import wikiDown from '~/components/common/wikiDown.vue'
export default {
  name: 'DealerDownload',
  components: {
    'qr-code': qrCode,
    'wiki-down': wikiDown,
    'common-img': commonImg
  },
  props: {
    state: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      isShow: false,
      info: null,
      desc: '',
      qrUrl: ''
    }
  },
  computed: {
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    },
    isWiki() {
      // 判断是否为国际
      if (this.$store.state.myCountry.toLowerCase() == 'cn') {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    this.qrUrl = 'https://' + window.location.host + `/${this.$store.state.LanguageCode}/download.html`
  },
  methods: {
    open(info, desc) {
      this.isShow = true
      this.desc = desc
      this.info = info
    },
    close() {
      this.isShow = false
    }
  }
}
